import { MailDestinataireContactInput } from './mail-destinataire-contact-input';

export class MailDestinataireEditInput {
  public statut?: string; // Statut description
  public action?: string; //  Action description
  public transmisDate?: string; // ($date-time)
  public echeance?: string; // ($date - time)
  public message?: string;
  public accuseDeReponse: boolean; // Accuse de reponse / Suivi de reponse
  public libre?: string;
  public serviceProprietaireId?: number; //  Au nom du service expéditeur
  public serviceDestinataireId?: number; // Au nom du service destinataire
  public contact: MailDestinataireContactInput;
}
